import { Space, Dropdown, Menu, Row, Col, Radio, RadioChangeEvent, Badge, ConfigProvider } from "antd";
import { DownOutlined, TagsOutlined, DollarOutlined } from '@ant-design/icons';
import { ColumnsType } from "antd/lib/table";
import { useState, useEffect } from "react";
import { getRequestLabSupport, getRequestLabParsicUser, getRequestLabisLabUser, getLabInstallerItems, deleteInstallRequestLab, getParsicUser, getLabList, UpdateLabInstallRequest } from "../../api/api";
import CustomTable from "../../components/_common/Table";
import { useAppDispatch, useAppSelector } from "../../redux/store/storehooks";
import { errorNotify, errorNotifyByErrorObject } from "../../services/toast.notification";

import { LabListContainer } from "../financial/style";

import { SendCabledialog } from "./DeliveryInstall​";
import { RequestVmachineModal } from "./RequestVmachine";
import { Factor } from "./factor";
import { AssignInstallerDialogRequestLab } from "./AssignInstaller";
import './style.css'
import CustomSelect from "../../components/_common/CustomSelect";
import { UpdateLabList } from "../../redux/reducers/lablistSlice";
import fa_IR from "antd/lib/locale/fa_IR";
import { DatePicker as DatePickerJalali, JalaliLocaleListener } from "antd-jalali";

const RequestLab = () => {
    const [showSendCableDialog, setshowSendCableDialog] = useState(false);
    const [showSendMachin, setShowMachinDialog] = useState(false);
    const [showFactor, setShowFactor] = useState(false);
    const [showAssignInstallerDialog, setAssignInstaller] = useState(false);

    const [sendLabId, setLabId] = useState({ labId: '0' });
    const [assignInstaller, setInstaller] = useState({ labId: '0' });
    const [loadInstallerData, setLoadInstallerData] = useState(false);

    const [sendCablePayload, setSendCableDialogPayload] = useState({ cableRequestId: 0, machineInstallRequestId: 0, labId: 0, installItems: [] });
    const [sendMobile, setMobile] = useState({ mobile: '0' });
    const [selectedLab, setSelectedLab] = useState("0");
    const myStore = useAppSelector((state) => state)
    const [isLoading, setIsLoading] = useState(true);
    const [financialList, setFinancialList] = useState<any[]>([]);
    const [allFinancialList, setAllFinancialList] = useState<any[]>([]);

    const [labList, setLabList] = useState<any[]>([]);

    const [showUploadDialog, setShowUploadDialog] = useState(false);
    const [uploadDialogPayload, setUploadDialogPayload] = useState({ labId: 0, payId: 0 });
    const [debtor, setdebtor] = useState(0);
    const [creditor, setCreditor] = useState(0);
    const [reminder, setReminder] = useState(0);
    const [showPaymentDialog, setShowPaymentDialog] = useState(false);
    const [paymentDialogPayload, setPaymentDialogPayload] = useState({ requestid: 0, machineName: "", bill: undefined, bankAccount: undefined });
    const [showGenerateBillDialog, setShowGenerateBillDialog] = useState(false);

    const [firstDate, setFirstDate] = useState<any>(undefined);
    const [lastDate, setLastDate] = useState<any>(undefined);
    
    const [generateBillDialogPayload, setGenerateBillDialogPayload] = useState({ labId: 0 });
    const [permission, setPermission] = useState(false);
    const [printMode, setPrintMode] = useState(false);
    const [userList, setUserList] = useState<any[]>([]);
    const [choosenInstaller, setChoosenInstaller] = useState('-1');
    const [statusList, setStatusList] = useState<any[]>([
        { status_id: '0', status_name: "همه وضعیت ها" },
        { status_id: '-1', status_name: "ثبت اولیه" },
        { status_id: '-2', status_name: "درخواست قرارداد" },
        { status_id: '-3', status_name: "درخواست فاکتور" },
        { status_id: '2', status_name: "در حال نصب" },
        { status_id: '1', status_name: "اتمام نصب" }
    ]);
    const [choosenStatus, setChoosenStatus] = useState('0');
    const [choosenLab, setChoosenLab] = useState('0');

    const dispatch = useAppDispatch();

    const columns: ColumnsType<any> = [

        {
            title: 'عملیات',
            dataIndex: 'Action', key: 'Action', render: (_, record) => (
                <Dropdown overlay={menu(record)}>
                    <a onClick={(e) => e.preventDefault()}>
                        <Space>
                            <DownOutlined />
                        </Space>
                    </a>
                </Dropdown>
            )
        },
        { title: 'نام آزمایشگاه', dataIndex: 'str_LabPersianName', key: 'str_LabPersianName' },
        { title: 'شماره موبایل', dataIndex: 'str_MobileNumber', key: 'str_MobileNumber' },
        { title: 'تاریخ شروع نرم افزار', dataIndex: 'str_StartUsingSoftwareDate', key: 'str_StartUsingSoftwareDate' },
        { title: 'استان', dataIndex: 'str_StateName', key: 'str_StateName' },
        // { title: 'ایمیل', dataIndex: 'str_Email', key: 'str_Email' },
        { title: 'وضعیت', dataIndex: 'str_Status', key: 'str_Status' },
        {
            title: 'درخواست قرارداد', dataIndex: 'bit_Contract', key: 'bit_Contract', render: (_, record) => (
                <Space size="middle">
                    <Badge status={record.bit_Contract ? "success" : "warning"} text={record.bit_Contract ? "دارد" : "ندارد"} />
                </Space>
            )
        },
        {
            title: 'درخواست فاکتور', dataIndex: 'bit_Invoice', key: 'bit_Invoice', render: (_, record) => (
                <Space size="middle">
                    <Badge status={record.bit_Invoice ? "success" : "warning"} text={record.bit_Invoice ? "دارد" : "ندارد"} />
                </Space>
            )
        },
        { title: 'تعداد کامپیوتر', dataIndex: 'int_TotalNumberofComputers', key: 'int_TotalNumberofComputers' },
        { title: 'آدرس', dataIndex: 'str_Address', key: 'str_Address' },
        { title: 'تلفن مستقیم', dataIndex: 'str_DirectTel', key: 'str_DirectTel' },
        { title: 'کد اقتصادی', dataIndex: 'str_Economicode', key: 'str_Economicode' },
        { title: ' موسس', dataIndex: 'str_ManagerName', key: 'str_ManagerName' },
        { title: 'شناسه ملی', dataIndex: 'str_TaxnationalCode', key: 'str_TaxnationalCode' },
        { title: ' تایید کننده مالی ', dataIndex: 'str_FinancialApproveId', key: 'str_FinancialApproveId' },
        { title: 'تاریخ تایید مالی ', dataIndex: 'financialApproveDateTime', key: 'financialApproveDateTime' },
        { title: ' ژنتیک', dataIndex: 'str_IsGenetics', key: 'str_IsGenetics' },
        { title: 'موبایل مدیر', dataIndex: 'str_ManagerMobile', key: 'str_ManagerMobile' },
        { title: 'پاتولوژی', dataIndex: 'str_Patolozhi', key: 'str_Patolozhi' },
        { title: 'کدپستی', dataIndex: 'str_PostalCode', key: 'str_PostalCode' },

        { title: 'نصاب', dataIndex: 'str_CenteralInstallerUserID', key: 'str_CenteralInstallerUserID' },
        { title: 'تاریخ انتخاب نصاب', dataIndex: 'str_AssignToInsaller_Date', key: 'str_AssignToInsaller_Date ' },
        { title: 'تاریخ اتمام نصب', dataIndex: 'str_CompleteInstall_Date', key: 'str_CompleteInstall_Date' },

        // { title: 'بدهکار', dataIndex: 'prk_installLabRequest_AutoID', key: 'prk_installLabRequest_AutoID' },
        // { title: 'شناسه', dataIndex: 'prk_AndriodLab_AutoID', key: 'prk_AndriodLab_AutoID' },

        // { title: 'تاریخ تکمیل نصب  ', dataIndex: 'str_CenteralInstallerDateTime', key: 'str_CenteralInstallerDateTime' },
        { title: 'نرم افزار فعلی', dataIndex: 'str_CurrentSoftware', key: 'str_CurrentSoftware' },

        // { title: 'تاریخ درخواست', dataIndex: 'str_TimeStamp', key: 'str_TimeStamp' },
        { title: 'آنتی ویروس', dataIndex: 'str_VirusSoftwareName', key: 'str_VirusSoftwareName' },
        { title: 'تاریخ درخواست', dataIndex: 'requestDateTime', key: 'requestDateTime' },

    ];

    const [valueWorke, setValueWork] = useState(2);
    const onChange = (e: RadioChangeEvent) => {
        console.log('radio checked', e.target.value);
        setValueWork(e.target.value);
        // b
        loadDataSupport(getFirstDate(), getLastDate(), e.target.value)
    };

    const SendDeliverryInstall = (id: number, machineInstallRequestId: number, labId: number) => {

        setshowSendCableDialog(true);
        loadInstallerItems(labId, Number(myStore.auth.userId));
        setSendCableDialogPayload((values: any) => ({
            ...values,
            cableRequestId: id,
            machineInstallRequestId: machineInstallRequestId,
            labId: labId
        }));
    }

    const loadInstallerItems = (labId: number, userId: number) => {

        getLabInstallerItems(userId, labId)
            .then((result: any) => {
                setSendCableDialogPayload((values: any) => ({
                    ...values,
                    installItems: result.data.data
                }));
                //setLabInstallationItems(result.data.data);
            })
            .catch((error: any) => {
                console.log(error);
                errorNotifyByErrorObject(error, undefined, 5000)
            })

        // getLabInstallationItems()
        //     .then((result: any) => {
        //         setLabInstallationItems(result.data.data);
        //     })
        //     .catch((error: any) => {
        //         console.log(error);
        //         errorNotifyByErrorObject(error, undefined, 5000)
        //     })

    }


    const SendNewFactor = (requestId: any, labId: any) => {

        setShowFactor(true);
        setLabId((values: any) => ({
            ...values,
            labId: Number(labId),
            requestId: requestId
        }));
    }

    const SendNewInstaller = (item: any) => {
        setAssignInstaller(true);
        setInstaller((values: any) => ({
            ...values,
            requestId: item.prk_installLabRequest_AutoID,
            labId: item.prk_AndriodLab_AutoID
        }));
    }

    const SendRequestVmachine = (mobileNumber: any, id: any, labId: any, frk_CenteralInstallerUserID: any) => {

        setShowMachinDialog(true);

        setMobile((values: any) => ({
            ...values,
            mobile: mobileNumber,
            prk_installLabRequest_AutoID: id,
            labId: labId,
            frk_CenteralInstallerUserID: frk_CenteralInstallerUserID
            // machineInstallRequestId:machineInstallRequestId,
        }));

    }
    const loadParsicUsers = () => {

        getParsicUser()
            .then((result: any) => {
                setUserList(result.data.data)
                userListInitilization(result.data.data)

                setIsLoading(false);
            })
            .catch((error: any) => {
                console.log(error);
                errorNotifyByErrorObject(error, undefined, 5000)
            })

    }

    const userListInitilization = (userItems: any) => {
        let allUserItem = { prk_ParsicUser_AutoID: -1, str_FullName: "همه نصاب ها " }
        setUserList([allUserItem, ...userItems])
        setIsLoading(false)
    }

    const menu = (record: any) => (
        //     <Space>
        //          <Button type="primary" style={{backgroundColor:"green"}} onClick={()=>
        //         SendDeliverryInstall(record.prk_AndriodLab_AutoID,record.frk_MachineInstallRequestID,
        //             record.prk_AndriodLab_AutoID)}> تحویل نصب</Button>
        //              <Button type="primary" style={{backgroundColor:"orange"}} onClick={()=>

        //         SendRequestVmachine(
        //record.str_MobileNumber,record.prk_installLabRequest_AutoID,record.prk_AndriodLab_AutoID)}> 
        //  درخواست آنالایزر</Button>

        // <Button type="primary" style={{backgroundColor:"green"}} onClick={()=>
        //         SendNewFactor(record.prk_AndriodLab_AutoID)}> ثبت فاکتور </Button>
        //         <Button type="primary" style={{backgroundColor:"green"}} onClick={()=>
        //         SendNewInstaller(record)}>  تایین نصاب </Button>
        //     </Space>
        <Menu
            items={[
                {
                    key: "1",
                    label: "تحویل نصب ",
                    onClick: () => SendDeliverryInstall(record.prk_AndriodLab_AutoID, record.frk_MachineInstallRequestID,
                        record.prk_AndriodLab_AutoID),
                    style: { 'display': (myStore.auth.loginType == 'lab' || myStore.auth.loginType == 'labuser') ? 'none' : '' },
                    //  disabled:!(myStore.auth.loginType === 
                    //'parsicuser' && record.bill===0 && record.bit_HaveInvoice===0
                    // && record.str_Amount != "0")
                    //disabled: (record.frk_CenteralInstallerUserID == 0 || !permission)
                },
                {
                    key: "2",
                    label: " درخواست آنالایزر",
                    onClick: () => SendRequestVmachine(record.str_MobileNumber, record.prk_installLabRequest_AutoID, record.prk_AndriodLab_AutoID, record.frk_CenteralInstallerUserID),
                    icon: <TagsOutlined />,
                    disabled: !permission
                    //disabled:(record.frk_CenteralInstallerUserID==0) 
                    // disabled: !(myStore.auth.loginType === 'parsicuser' && record.bill===0 && record.bit_HaveInvoice===1 && record.str_Amount != "0") 

                },
                {
                    key: "3",
                    label: " ثبت فاکتور",
                    onClick: () => SendNewFactor(record.prk_installLabRequest_AutoID, record.prk_AndriodLab_AutoID),
                    icon: <DollarOutlined />,
                    style: {
                        'display': (myStore.auth.loginType == 'lab' || myStore.auth.loginType == 'labuser') ?
                            'none' : (myStore.auth.loginType == 'parsicuser' && myStore.auth.manager == false) ? 'none' : ''
                    },
                    disabled: (record.int_Status !== -1 || !permission)
                    // disabled: !(myStore.auth.loginType === 'parsicuser' && record.bill===1 && record.int_TotalPay < record.int_Amount)

                },
                {
                    key: "4",
                    label: "قرارداد منعقد شده",
                    onClick: () => _updateLabInstallRequest(record.prk_installLabRequest_AutoID, 2),
                    style: {
                        'display': (myStore.auth.loginType == 'lab' || myStore.auth.loginType == 'labuser') ?
                            'none' : (myStore.auth.loginType == 'parsicuser' && myStore.auth.manager == false) ? 'none' : ''
                    },
                    disabled: (record.int_Status !== 1 || !permission)

                },
                {
                    key: "5",
                    label: "پرداخت بند اول",
                    onClick: () => _updateLabInstallRequest(record.prk_installLabRequest_AutoID, 4),
                    style: {
                        'display': (myStore.auth.loginType == 'lab' || myStore.auth.loginType == 'labuser') ?
                            'none' : (myStore.auth.loginType == 'parsicuser' && myStore.auth.manager == false) ? 'none' : ''
                    },
                    disabled: (record.int_Status !== 2 || !permission)

                },
                {
                    key: "6",
                    label: " نصاب آزمایشگاه ",
                    onClick: () => SendNewInstaller(record),
                    //disabled: (record.frk_CenteralInstallerUserID != 0 || !permission)
                    // disabled:  !( myStore.auth.loginType === 'labuser' && record.bill===0 && record.str_Amount != "0")
                },
                {
                    key: "7",
                    label: "حذف",
                    onClick: () => DeleteLab(record),
                }
            ]}
        />
    )

    const onStatusChange = (event: any) => {
        setChoosenStatus(event.target.value);
        // addFilter();
    };

    const onInstallerChange = (event: any) => {
        setChoosenInstaller(event.target.value);
        //addFilter();
    };

    const onLabChange = (event: any) => {
        setChoosenLab(event.target.value);
        //addFilter();
    };
    useEffect(() => {

        loadParsicUsers();

        loadFinancialBalance(0)


        if (myStore.auth.loginType == 'labuser') {

            setChoosenLab(myStore.auth.userId ? myStore.auth.userId.toString() : '0')
        }
        else {
            if (!myStore.labList.list) {
                loadLabs()
            }
            else {
                setLabList(myStore.labList.list);
                LabListInitilization(myStore.labList.list);

            }
        }


        if (myStore.auth.loginType === 'parsicuser') {
            myStore.auth.permission.map((item: any) => {
                if (item.pageName == 'RequestLab')
                    setPermission(item.isDetailAccess);
            });
        }
        else {
            setPermission(true);
        }
    }, [])

    useEffect(() => {
        addFilter();
    }, [choosenStatus, choosenInstaller, allFinancialList, choosenLab]);


    const loadLabs = () => {

        getLabList()
            .then((result: any) => {
                dispatch(UpdateLabList({ labList: result.data.data }))
                setLabList(myStore.labList.list);
                LabListInitilization(myStore.labList.list)
                // loadMachineInstallRequest();

                setIsLoading(false);
            })
            .catch((error) => {
                console.log(error);
                errorNotify(error.response.data.errorMessage, undefined, 5000)
            })

    }

    const LabListInitilization = (labItems: any) => {

        let allLabItem = { prk_AndriodLab_AutoID: 0, str_LabPersianName: "همه آزمایشگاه ها" }
        setLabList([allLabItem, ...labItems])
        setIsLoading(false)
    }

    const loadFinancialBalance = (firstDate: any = undefined, lastDate: any = undefined, byFinancial: any = undefined) => {
        if (myStore.auth.loginType == 'lab' || myStore.auth.loginType == 'labuser')
            loadDataLabUser();
        // manager":false,
        else if (myStore.auth.loginType == 'parsicuser' && !myStore.auth.manager)
            loadDataParsicUser();
        else
            // همه0
            // انجام داده 1
            // مانده 2
            // دیفالت 2
            //byFinancial==  (0 == all 1 == work 2==)
            loadDataSupport(firstDate, lastDate, byFinancial);

    }
    const loadDataSupport = (firstDate: any = undefined, lastDate: any = undefined
        , byFinancial: any = undefined) => {

        setIsLoading(true);

        getRequestLabSupport(firstDate ? firstDate : getFirstDate(),
            lastDate ? lastDate : getLastDate(), byFinancial ? byFinancial : 2)
            .then((result: any) => {

                if(result.data.data != null && result.data.data.length>0){
                    var result_data = result.data.data.filter((a: any) => !a.deleteRequest)
                    setFinancialList(result_data);
                    setAllFinancialList(result_data)
                    briefCalculator(result_data);
                }
                else
                setFinancialList([]);
              
                setIsLoading(false);
            })
            .catch((error) => {
                console.log(error);
                errorNotify(error.response.data.errorMessage, undefined, 5000)
            })
    }
    const loadDataParsicUser = () => {

        setIsLoading(true);

        getRequestLabParsicUser(myStore.auth.userId)
            .then((result: any) => {

                setFinancialList(result.data.data);
                briefCalculator(result.data.data);
                setIsLoading(false);
            })
            .catch((error) => {
                console.log(error);
                errorNotify(error.response.data.errorMessage, undefined, 5000)
            })
    }
    const loadDataLabUser = () => {

        setIsLoading(true);

        getRequestLabisLabUser(myStore.auth.userId)
            .then((result: any) => {

                setFinancialList(result.data.data);
                briefCalculator(result.data.data);
                setIsLoading(false);
            })
            .catch((error) => {
                console.log(error);
                errorNotify(error.response.data.errorMessage, undefined, 5000)
            })
    }
    const briefCalculator = (list: any) => {

        if (list != undefined) {

            let value: number = 0;
            let debt: number = 0;
            let pay: number = 0;

            setdebtor(0);
            setCreditor(0);
            setReminder(0);


            list.forEach((element: any) => {
                element.bill === 1 ? debt = debt + element.int_Amount : pay = pay + element.int_Amount;
            });

            setdebtor(debt);
            setCreditor(pay);
            setReminder(debt - pay);
        }
        else {
            setdebtor(0);
            setCreditor(0);
            setReminder(0);
        }
    }

    const onChangeDatePicker = (dates: any, dateStrings: any, info: any) => {

        console.log(dates);
        if (!dateStrings) return;
        if (dateStrings.length < 2) return;
        if (dateStrings[0] === "") return;
        if (dateStrings[1] === "") return;

        setFirstDate(dates[0])
        setLastDate(dates[1])
        loadFinancialBalance(dates[0].format('YYYY-MM-DD'), dates[1].format('YYYY-MM-DD'));
    }
    const addFilter = () => {
        let filtered = [...allFinancialList];

        // فیلتر وضعیت
        if (choosenStatus !== '0') {
            if (choosenStatus === '-2') {
                filtered = filtered.filter(
                    item => item.bit_Contract
                );
            }
            else if (choosenStatus === '-3') {
                filtered = filtered.filter(
                    item => item.bit_Invoice
                );
            }
            else {
                filtered = filtered.filter(
                    item => String(item.int_Status) === String(choosenStatus)
                );
            }
        }


        // فیلتر نصاب
        if (choosenInstaller !== '-1') {
            filtered = filtered.filter(
                item => item.frk_CenteralInstallerUserID === Number(choosenInstaller)
            );
        }

        // فیلتر آزمایشگاه
        if (choosenLab !== '0') {
            filtered = filtered.filter(
                item => String(item.prk_AndriodLab_AutoID) === String(choosenLab)
            );
        }

        setFinancialList(filtered);
    };


    const getFirstDate = () => {
        return firstDate ? firstDate.format('YYYY-MM-DD') : undefined
    }

    const getLastDate = () => {
        return lastDate ? lastDate.format('YYYY-MM-DD') : undefined
    }

    const handlePrint = () => {
        setPrintMode(true);

        setTimeout(() => {
            window.print();
            setPrintMode(false);
        }, 300);
    };

    const DeleteLab = (record: any) => {
        setIsLoading(true);
        deleteInstallRequestLab(record.prk_installLabRequest_AutoID)
            .then((result: any) => {
                loadFinancialBalance(0);
                setIsLoading(false);
            })
            .catch((error) => {
                console.log(error);
                errorNotify(error.response.data.errorMessage, undefined, 5000)
            })
    }

    const _updateLabInstallRequest = (requestId: any,status:number) => {
        setIsLoading(true);
        UpdateLabInstallRequest(requestId,status)
            .then((result: any) => {
                loadFinancialBalance(0);
                setIsLoading(false);
            })
            .catch((error) => {
                console.log(error);
                errorNotify(error.response.data.errorMessage, undefined, 5000)
            })
    }

    

    return (
        <>
            {/* <Button
                icon={<PrinterOutlined />}
                type="primary"
                onClick={handlePrint}
            >
                پرینت
            </Button> */}
            <LabListContainer>
                {(() => {
                    // (myStore.auth.loginType!="lab"
                    // && myStore.auth.loginType!="parsicuser"
                    if (myStore.auth.loginType == "Support" ||
                        (myStore.auth.loginType == "parsicuser" &&
                            myStore.auth.manager == true)) {
                        return (
                            <>

                                <Row>
                                    <Col lg={8} md={8} sm={24} xs={24}>
                                        <CustomSelect
                                            name="machine"
                                            placeholder="وضعیت نصب"
                                            itemList={statusList}
                                            value={choosenStatus || "0"}
                                            onChange={onStatusChange}
                                            valueObjectField={"status_id"}
                                            displayObjectField={"status_name"}

                                        />
                                    </Col>
                                    <Col lg={8} md={8} sm={24} xs={24}>
                                        <CustomSelect
                                            name="parsicUser"
                                            placeholder="نصاب دستگاه"
                                            itemList={userList}
                                            value={choosenInstaller || "-1"}
                                            onChange={onInstallerChange}
                                            valueObjectField={"prk_ParsicUser_AutoID"}
                                            displayObjectField={"str_FullName"}
                                        />
                                    </Col>

                                    <Col lg={8} md={8} sm={24} xs={24}>
                                        <CustomSelect
                                            name="lab"
                                            placeholder="آزمایشگاه"
                                            itemList={labList}
                                            value={choosenLab || "0"}
                                            onChange={onLabChange}
                                            valueObjectField={"prk_AndriodLab_AutoID"}
                                            displayObjectField={"str_LabPersianName"}
                                        />
                                    </Col>
                                </Row>

                                <Row>
                                    <Col lg={8} md={8} sm={24} xs={24}>
                                        <Radio.Group
                                            style={{ marginTop: '15px', float: 'right' }}
                                            onChange={onChange} value={valueWorke}>
                                            <Radio value={2}> مانده </Radio>
                                            <Radio value={1}>  انجام داده</Radio>
                                            <Radio value={0}>  همه </Radio>
                                        </Radio.Group>
                                    </Col>
                                    <Col lg={8} md={8} sm={24} xs={24}>
                                    <div
                                        style={{ marginTop: '4px' }}
                                        className="calender">
                                        <ConfigProvider locale={fa_IR} direction="rtl">
                                            <JalaliLocaleListener />
                                            <DatePickerJalali.RangePicker value={[firstDate, lastDate]}
                                                onCalendarChange={(dates: any, dateStrings: any, info: any) =>
                                                    onChangeDatePicker(dates, dateStrings, info)} />
                                        </ConfigProvider>
                                    </div>
                                    </Col>
                                </Row>
                            </>
                        )
                    }
                })()}

                <SendCabledialog
                    visible={showSendCableDialog}
                    onSubmit={() => console.log(true)}
                    onCancel={() => { setshowSendCableDialog(false); loadFinancialBalance(0); }}
                    payLoad={sendCablePayload}
                    setShowDialog={() => { setshowSendCableDialog(false); loadFinancialBalance(0); }}
                />

                {(() => {
                    if (showAssignInstallerDialog) {
                        return <AssignInstallerDialogRequestLab
                            visible={showAssignInstallerDialog}
                            onSubmit={() => console.log(true)}
                            onCancel={() => { setAssignInstaller(false); loadFinancialBalance(0); }}
                            payLoad={assignInstaller}
                            setShowDialog={(value) => setAssignInstaller(value)}
                        />
                    }
                })()}
                {(() => {
                    if (showFactor) {
                        return <Factor
                            visible={showFactor}
                            onSubmit={() => console.log(true)}
                            onCancel={() => { setShowFactor(false); loadFinancialBalance(0); }}
                            payLoad={sendLabId}
                            setShowDialog={(value) => setShowFactor(value)}
                        />
                    }
                })()}

                {(() => {
                    if (showSendMachin) {
                        return <RequestVmachineModal
                            visible={showSendMachin}

                            onSubmit={() => console.log(true)}
                            onCancel={() => { setShowMachinDialog(false); loadFinancialBalance(0); }}
                            payLoad={sendMobile}
                            setShowDialog={() => { setShowMachinDialog(false); loadFinancialBalance(0); }}
                        />
                    }
                    // else {
                    //    return <p>hide</p>
                    // }
                })()}

            </LabListContainer>

            <Row>              
                    <CustomTable
                        columns={columns} data={financialList}
                        isloading={isLoading} onAddClick={undefined}
                        permission={permission}
                    />
            </Row>
        </>
    );
}
export default RequestLab